<div class="invalid-feedback validation-error">
    <div *ngIf="showErrors" class="validation-error-msg">{{error}}</div>
</div>